export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6909.6533ed82.jpg";